import { Injectable } from "@angular/core";


@Injectable({
	providedIn: 'root'
})
export class CryptoRandomFloat {
static getCryptoRandomFloat() {
    // Create a TypedArray for 32-bit unsigned integer
    const array = new Uint32Array(1);
    
    // Populate the array with cryptographically strong random values
    window.crypto.getRandomValues(array);
    
    // Convert the random integer to a float in the range [0, 1)
    // We achieve this by dividing the integer by the maximum possible value + 1 (0xFFFFFFFF + 1)
    return array[0] / (0xFFFFFFFF + 1);
  }


}